import clsx from 'clsx';

import elementIcon from '@atom/components/common/svgIcons/elementIcon.svg';
import { useNavigation } from '@atom/hooks/useNavigation';
import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import classes from './moveElement.module.css';

const styles = {
  icon: {
    marginRight: '1rem',
  },
};

interface Props {
  element: any;
  fromAssetDisplay: string;
  fromAssetId: string;
  toAssetDisplay: string;
  toAssetId: string;
  isReplaceElement?: boolean;
  pastTense?: boolean;
}

const ElementInfoBox = ({
  element,
  fromAssetDisplay,
  fromAssetId,
  toAssetDisplay,
  toAssetId,
  isReplaceElement,
  pastTense,
}: Props) => {
  const [, { Link }] = useNavigation();

  const buildSubText = (attributes: any): string => {
    return attributes.reduce((acc: string, attribute): any => {
      if (!attribute.isVisibleAsSubtext) {
        return acc;
      }

      const label = attribute.name;
      const value = attributeDisplayUtility.display(
        attribute.value,
        attribute.dataType,
        attribute.unit,
      );

      const text = `${label}: ${value}`;
      return acc ? `${acc}, ${text}` : text;
    }, '');
  };

  const getAttributeSubText = () => {
    if (isNilOrEmpty(element.attributeGroups)) {
      return '';
    }

    const attributes = element.attributeGroups.reduce((acc, group) => {
      return [...acc, ...group.attributes];
    }, []);

    return buildSubText(attributes);
  };

  const getReplaceAttributeSubText = () => {
    if (isNilOrEmpty(element.attributeGroups)) {
      return '';
    }

    const attributes = element.attributeGroups.reduce((acc, group) => {
      return [
        ...acc,
        ...group.attributes.map(attributeId => element.attributes[attributeId]),
      ];
    }, []);

    return buildSubText(attributes);
  };

  const subtext = isReplaceElement
    ? getReplaceAttributeSubText()
    : getAttributeSubText();

  const displayText = pastTense ? 'Moved from' : 'Moving from';

  return (
    <div className={classes.infoBox}>
      <div className={classes.elementBox}>
        <img style={styles.icon} src={elementIcon} />
        <div>
          <div className={classes.title}>{element.name}</div>
          <div className={classes.subtext}>{subtext}</div>
        </div>
      </div>
      <div className={classes.linkBox}>
        <span>
          {displayText}
          <span className={classes.link}>
            <Link
              to={`/inventory/${fromAssetId}?activeView=subItems`}
              target="_blank"
            >
              {fromAssetDisplay}
            </Link>
          </span>
          to
          <span className={clsx(classes.link, classes.last)}>
            <Link
              to={`/inventory/${toAssetId}?activeView=subItems`}
              target="_blank"
            >
              {toAssetDisplay}
            </Link>
          </span>
          .
        </span>
      </div>
    </div>
  );
};

export default ElementInfoBox;
